import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import "./Topic.css";

const Topic = ({ quiz }) => {
  const { id, name, logo, total } = quiz;

  return (
    <div className="mb-12 ">
      <div className="border p-2 rounded bg-emerald-200 drop-shadow-xl topic-container">
        <img className="flex w-60 bg-slate-800 logo" src={logo} alt="" />
        <div className=" justify-between mt-6 button-container">
          <div className="font-bold text-center text-xl mb-2">{name}</div>
          <div className="font-bold text-center mb-2 text-red-500">
            Total Quiz: {total}
          </div>
          <div>
            <Link to={`/quiz/${id}`}>
              <button className="font-bold text-sm py-1 px-2  w-full bg-blue-600 hover:bg-blue-700 rounded-lg text-white">
                Start Quiz
                {/* <span className="ml-2">
                  <FontAwesomeIcon icon={faArrowRight}></FontAwesomeIcon>
                </span> */}
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topic;
